// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phonebook';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.75 17.438H3.937A1.687 1.687 0 0 1 2.25 15.75M4.5.563a2.25 2.25 0 0 0-2.25 2.25V15.75a1.687 1.687 0 0 1 1.688-1.688h11.25a.562.562 0 0 0 .562-.562V1.125a.563.563 0 0 0-.563-.563zm10.125 16.875v-3.375' />
    <path d='m8.811 10.26 1.808-1.785a1.125 1.125 0 0 1 1.591 0l.398.398a1.125 1.125 0 0 1 0 1.59l-.345.346a1.126 1.126 0 0 1-1.069.3l-.654-.164A7.109 7.109 0 0 1 5.365 5.77l-.16-.652a1.125 1.125 0 0 1 .296-1.068l.345-.345a1.125 1.125 0 0 1 1.591 0l.398.397a1.125 1.125 0 0 1 0 1.591l-1.79 1.8' />
  </g>
);

export const viewBox = '0 0 18 18';
